import { BlockTitle } from "@src/app/blocks/Blocks";

type HeaderProps = {
  /** The title of the accordion item, will be displayed at accordion header. */
  title: string;
};

/**
 * component to render SIA accordion header
 */
const SIAAccordionHeader = ({ title }: HeaderProps): React.ReactElement => {
  return (
    <BlockTitle
      text={title}
      rootClassName="text-base lg:text-base mb-0 font-public-sans font-semibold tracking-2% hover:underline px-6 text-left"
    />
  );
};

export default SIAAccordionHeader;
